import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { AccountService } from './_services';
import { CompanyService } from './_services/company.service';
import { User } from './_models';

@Component({ selector: 'app-root', templateUrl: 'app.component.html' })
export class AppComponent {
    user?: User | null;
    companyName = '';
    showDropdown = false;
    sidebarCollapsed = false; // Default to collapsed
    isMobile = false;
    purchaseMenuExpanded = false;
    adminMenuExpanded = false;
    payrollMenuExpanded = false;

    constructor(
        public accountService: AccountService,
        private companyService: CompanyService,
        private router: Router
    ) {
        this.accountService.user.subscribe(user => {
            this.user = user;
            this.loadCompanyName();
        });
        console.log(this.user);
        this.checkScreenSize();
    }

    private loadCompanyName() {
        if (!this.user?.companyId) {
            this.companyName = '';
            return;
        }

        this.companyService.getById(this.user.companyId.toString()).subscribe({
            next: company => this.companyName = company.name || '',
            error: () => this.companyName = ''
        });
    }
    
    getUserInitials(): string {
        if (!this.user?.firstName || !this.user?.lastName) {
            return 'U';
        }
        return (this.user.firstName.charAt(0) + this.user.lastName.charAt(0)).toUpperCase();
    }
    
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }
    
    toggleSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
    }
    
    togglePurchaseMenu() {
        this.purchaseMenuExpanded = !this.purchaseMenuExpanded;
    }
    
    toggleAdminMenu() {
        this.adminMenuExpanded = !this.adminMenuExpanded;
    }
    
    togglePayrollMenu() {
        this.payrollMenuExpanded = !this.payrollMenuExpanded;
    }
    
    @HostListener('document:keydown.escape')
    onEscapeKey() {
        this.showDropdown = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.checkScreenSize();
    }
    
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const target = event.target as HTMLElement;
        const dropdown = target.closest('.user-avatar-container');
        const sidebar = target.closest('.sidebar');
        const toggleBtn = target.closest('.sidebar-toggle');
        
        if (!dropdown) {
            this.showDropdown = false;
        }
        
        // Close sidebar on mobile when clicking outside
        if (this.isMobile && !sidebar && !toggleBtn && !this.sidebarCollapsed) {
            this.sidebarCollapsed = true;
        }
    }
    
    private checkScreenSize() {
        this.isMobile = window.innerWidth <= 768;
        if (this.isMobile) {
            // On mobile, default to collapsed to maximize content space
            this.sidebarCollapsed = true;
        } else {
            // On desktop, default to expanded
            this.sidebarCollapsed = false;
        }
    }
    
    logout() {
        this.accountService.logout();
        this.showDropdown = false;
    }

    onPurchaseReturnClick() {
        console.log('Purchase Return link clicked');
        console.log('Current route:', this.router.url);
        console.log('Attempting to navigate to /purchase-return');
        
        this.router.navigate(['/purchase-return']).then(
            (success) => {
                console.log('Navigation success:', success);
                console.log('New route:', this.router.url);
            },
            (error) => {
                console.error('Navigation error:', error);
            }
        );
        
        if (this.isMobile) {
            this.toggleSidebar();
        }
    }

    onSupplierCreditNoteClick() {
        console.log('Supplier Credit Note link clicked');
        console.log('Current route:', this.router.url);
        console.log('Attempting to navigate to /supplier-credit-notes');
        
        this.router.navigate(['/supplier-credit-notes']).then(
            (success) => {
                console.log('Navigation success:', success);
                console.log('New route:', this.router.url);
            },
            (error) => {
                console.error('Navigation error:', error);
            }
        );
        
        if (this.isMobile) {
            this.toggleSidebar();
        }
    }
}